import { render, staticRenderFns } from "./ContractsOverviewTable.vue?vue&type=template&id=55b3785b"
import script from "./ContractsOverviewTable.vue?vue&type=script&lang=js"
export * from "./ContractsOverviewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports